import { LitElement, html, nothing } from 'lit';
import '../styles/login-app.css';
import './login.mjs';
import './reports.mjs';

class PN3App extends LitElement {
  createRenderRoot() {
    return this;
  }
  constructor() {
    super();
    this.loginState = 'LOGGED OUT';
  }

  login(event) {
    console.log('Login event received:', event.detail);
    this.loginState = event.detail.state;
    this.userInfo = event.detail.user;

    if (this.loginState === 'LOGGED IN') {
      this.currentPage = 'reportOptions';
    } else {
      this.currentPage = 'login';
    }
  }


  render() {
    return html` 
    <login-panel @login-event=${e => this.login(e)}></login-panel>
    ${this.loginState === 'LOGGED IN' ? html`<report-client></report-client>` : nothing}
    `;
  }

  static get properties() {
    return {
      loginState: { type: String },
      currentPage: { type: String },
    };
  }
}

window.customElements.define("pn3-app", PN3App);
